function isIE(userAgent) {
    userAgent = userAgent || navigator.userAgent;
    return userAgent.indexOf("MSIE ") > -1 || userAgent.indexOf("Trident/") > -1 || userAgent.indexOf("Edge/") > -1;
}

(function($){

	$(document).ready(function(){
		posts_grid_jscroll();
		wrap_iframes();		

		// set all external links to open in new tab
	    $('a').each(function() {
			var a = new RegExp('/' + window.location.host + '/');

			if((!a.test(this.href) && this.href.indexOf('mailto') != 0) || this.href.indexOf('.pdf') >= 0) {
            	$(this).prop('target','_blank');
            	$(this).addClass('external-link');
        	}	
			
	    });		

		$(document).on('click','.search-trigger',function(e){
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).siblings('.search-form').toggleClass('active');
			$(this).siblings('.search-form').find('.search-field').focus();
			$(this).siblings('.back-to-menu').addClass('active');
		});

		$(document).on('click','.back-to-menu',function(e){
			e.preventDefault();
			$(this).removeClass('active');
			$(this).siblings('.search-form').removeClass('active');
		});

		$(document).click(function(e){
			$is_search = (e.target.classList.contains('search-form') || e.target.classList.contains('search-field') || e.target.classList.contains('search-trigger'));

			if(!$is_search && $(window).width() > 991) {
				$('.search-form, .search-trigger').removeClass('active');
			}
		});

		$('body').on('click','#mobile-menu ul li.menu-item-has-children',function(e){
			if(!$(this).hasClass('active')) {
				e.preventDefault();
				$(this).addClass('active');
				$(this).find('.sub-menu').slideDown();
			} else {
				$(this).removeClass('active');
				$(this).find('.sub-menu').slideUp();
			}
		});

		
	    function posts_grid_jscroll() {
			if($('.posts--grid').length) {
				$('.posts--grid').jscroll({
					loadingHtml: '',
					loadingFunction: function() {
						$('.btn-loading-container').show();
					},
					nextSelector: '#posts--grid--next-page:last a.posts-next-link',
					contentSelector: '.posts--grid-content',
					autoTrigger: false,
					callback: function() {
						$('html,body').animate({scrollTop: $(this).offset().top - 300 }, 500);
						$('.btn-loading-container').hide();
					}
				});
			}
		}

		function wrap_iframes() {
			
			$('iframe[src*="vimeo"]').each(function(){
				// get the src
				var src = $(this).attr('src');
				// replace parameter with nothing
				$(this).attr('src',src.replace('dnt=1&', ''));
			});

			$('iframe[src*="vimeo"]').wrap("<div class='iframe-wrapper inline-vimeo'></div>");
			$('iframe[src*="youtube"]').wrap("<div class='iframe-wrapper inline-youtube'></div>");
		}
		
	});
	
})(jQuery);

// function onPlayerReady($player_obj) {
// 	$player_obj.closest('.video-wrapper').addClass('loaded');
// }

// window.onYouTubeIframeAPIReady = function() {

// 	setTimeout(function(){
		
// 		jQuery('.youtube-video').each(function(i){

// 			var varname = jQuery(this).attr('id');

// 			window[varname] = new YT.Player(jQuery(this).attr('id'), {
// 				width: '100%',
// 				height: '100%',
// 				videoId: jQuery(this).attr('data-video-id'),
// 				playerVars: { rel: 0 },
// 				origin: window.location.href,
// 				enablejsapi: 1,
// 				events: {
// 					'onReady': onPlayerReady(jQuery(this))
// 				}
// 			});
// 		});

// 	}, 300);
// };